import is from 'is_js';
import { List } from 'immutable';
import { LESSON_CATEGORY } from 'containers/Group/WritingAssignment';
import Status from './status';

const SHORT_ANSWER = 'shortAnswer';
const ESSAY = 'essay';

export function formatCategory(category) {
  if (`${category}`.toLowerCase() === 'catchup') {
    return 'Catch up';
  }
  return category;
}


export function formatActivityType(activityType) {
  if (isShortAnswer(activityType)) {
    return 'Short Answer';
  }
  return activityType;
}

export function getCoreWritingAssignment(state, groupId) {
  const coreWritingAssignment = state.get('rootReducer').get('coreWritingAssignment');
  const coreWritingAssignmentList = coreWritingAssignment && coreWritingAssignment.get(`${groupId}`);
  return coreWritingAssignmentList;
}

export function getSPINWritingAssignment(state, groupId) {
  const spinWritingAssignment = state.get('rootReducer').get('spinWritingAssignment');
  const spinWritingAssignmentList = spinWritingAssignment && spinWritingAssignment.get(`${groupId}`);
  return spinWritingAssignmentList;
}

export function getCoreWritingAssignmentLessons(state, groupId) {
  const overview = getCoreWritingAssignment(state, groupId);
  if (is.existy(overview)) {
    return overview.map((val, key) => ({
      lessonNo: val.lessonNo,
      unitNo: val.unitNo,
      seq: key,
    }));
  }
}

export function getCoreActivityByLessonAndStudentId(state, groupId, lessonSeq, studentId) {
  const overview = getCoreWritingAssignment(state, groupId);
  if (is.existy(overview)) {
    const activity = overview
      .get(lessonSeq)
      .get('studentActivities')
      .find((val) => val.studentId === studentId);
    return activity;
  }
}

export function getSpinActivityByActivityIdAndStudentId(state, groupId, activityId, studentId) {
  const overview = getSPINWritingAssignment(state, groupId);
  if (is.existy(overview)) {
    const allStudentActivities = overview.reduce((result, exam) =>
      result.concat(exam.studentActivities.toList()), new List());
    const activity = allStudentActivities
      .find((val) => val.studentId === studentId && val.activityId === activityId);
    return activity;
  }
}

export function getStudentActivityByLessonCategory(
  state,
  groupId,
  { lessonSeq, activityId },
  studentId
) {
  const lessonCategory = getLessonCategory({ lessonSeq, activityId });
  switch (lessonCategory) {
    case LESSON_CATEGORY.CORE_CATCH_UP:
      return getCoreActivityByLessonAndStudentId(state, groupId, lessonSeq, studentId);
    case LESSON_CATEGORY.SPIN:
      return getSpinActivityByActivityIdAndStudentId(state, groupId, activityId, studentId);
    default:
      break;
  }
}

export function getLessonCategory({ lessonSeq, activityId }) {
  if (is.not.undefined(lessonSeq) && is.undefined(activityId)) return LESSON_CATEGORY.CORE_CATCH_UP;
  if (is.undefined(lessonSeq) && is.not.undefined(activityId)) return LESSON_CATEGORY.SPIN;
}

export function getWritingAssignmentByActivityType(state, activityType, activityId, studentId) {
  const type = getActivityType(activityType);
  if (type.length > 0) {
    return state.get('rootReducer').get(type) &&
      state.get('rootReducer').get(type).get(`${activityId}-${studentId}`);
  }
}

export function isShortAnswer(activityType) {
  return is.string(activityType) && activityType.toLowerCase() === SHORT_ANSWER.toLowerCase();
}

export function isEssay(activityType) {
  return is.string(activityType) && activityType.toLowerCase() === ESSAY.toLowerCase();
}

function getActivityType(activityType) {
  if (is.string(activityType)) {
    return [ESSAY, SHORT_ANSWER].reduce((accumulator, currentValue) => {
      const current = (currentValue.toLowerCase() === activityType.toLowerCase()) ?
        currentValue : '';
      return accumulator + current;
    }, '');
  }
  return '';
}

function isShortAnswersChecked(shortAnswers) {
  if (! shortAnswers) return true;
  return shortAnswers.every(({ isCorrect }) => is.boolean(isCorrect));
}

function hasComment(comment, isShortAnswerFromParam) {
  return isShortAnswerFromParam || is.string(comment);
}

export function canPublish(writingAssignment, isShortAnswerFromParam) {
  if (! writingAssignment) return false;
  const { comment, status, shortAnswers } = writingAssignment;
  if (hasComment(comment, isShortAnswerFromParam) &&
    status === Status.INPROGRESS &&
    isShortAnswersChecked(shortAnswers)) {
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./data/WritingAssignment/accessors.js